module.exports = __webpack_public_path__ + "static/media/notification.c8749caa.png";